import React from "react";
import "./TISolidworks.css";
import { NavLink } from "react-router-dom";
import Teacher from "../../../../../assets/images/plmimplementationimage/Teacher-amico.png";
import TISolidworksOverview from "./TISolidworksOverview";
import Letsgetintouch from "../../../BusinessProcessAndChangeManagement/Letsgetintouch";
import FloatingContactUs from "../../../../floting_contact/FloatingContactUs";

const TISolidworks = () => {
  return (
    <section className="PLMERPData-management">
      <div className="banner">
        <div className="banner-content">
          <img src={Teacher} alt="teacher" className="banner-image" />
          <div className="banner-text">
            <h4 className="business-process-h4">
            Teamcenter Integration for SolidWorks 
            </h4>
          </div>
        </div>
      </div>
      <div>
         <FloatingContactUs />
      </div>

      <div className="container">
       <TISolidworksOverview />
        <div className="benefits">
          <h4 className="PLMERPData-page-heading">Unlock the Power :</h4>
          <h5 className="PLMERPData-subheading">
            Discover the Transformative Benefits of NexTech!
          </h5>
          <ul className="custom-bullets">
            <li>
            Less time spent by your technical staff in finding the correct revisions of CAD data 
            </li>
            <li>Consistent work process followed across all data formats</li>
            <li>
              Faster product change and approval processes resulting in
              decreased time-to-market
            </li>
            <li>
              CAD files integrated with all your technical data to provide a
              single source of product information that supports your complete
              design through- manufacturing process
            </li>
          </ul>
        </div>
        <div className="solutions container">
  <div className="solutions-content">
    <div className="row">
      {/* Left Section: PLM - ERP Solutions */}
      <div className="col-md-6 col-12">
        <h4 className="PLMERPData-page-heading">Our Solutions</h4>
        <p className="plmimplementationparagraph">
          2TIER & 4TIER integration, Synchronize title block using Teamcenter
          database attributes, Mechanical Properties Synchronization,
          Bidirectional Attribute Mapping, Seed Parts configuration, Server-based
          JT Translation (SW to JT).
        </p>
      </div>

      {/* Right Section: Quick Links */}
      <div className="col-md-6 col-12">
        <div className="quick-links">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <NavLink to={"/teamcenter/mcad-integration/nx-integration"}>
                Teamcenter Integration for NX
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/mcad-integration/pro-engineer-integration"}>
                Teamcenter Integration for Creo Pro/ENGINEER
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/mcad-integration/catia-integration"}>
                Teamcenter Integration for CATIA
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/mcad-integration/autocad-integration"}>
                Teamcenter Integration for AutoCAD
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/solidedge-integration"}>
                Teamcenter Integration for Solid Edge
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/mcad-integration"}>
                MCAD Integration
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/ecad-integration"}>
                ECAD Integration
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/business-process-management"}>
                Business Process and Change Management
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>


        <div className="solutions">
          
          <h4 className="PLMERPData-page-heading">Performance Tuning</h4>
          <p className="plmimplementationparagraph">
          We ensure right performance tuning by rightly configuring the OS, Hardware, Server & Client system component which help you get right performance while performing various activities in SolidWorks manage mode including smart saves, Teamcenter Driven CAD properties, SQL tuning etc.  
          </p>
   
        </div>

        <div className="best-practices">
          <h4 className="PLMERPData-page-heading">Best Practices</h4>
          <p className="plmimplementationparagraph">
          We help you to use best practices while performing various activities in manage mode environments on SolidWorks data create, configure, edit models, drawing, assemblies along with relationship and associated auxiliary files, JT conversion, storing mechanical properties, working in multiple sessions, CAD centric data transfer in multisite, design tables, bidirectional product structure editing. 
          </p>
        </div>

        <div className="migration">
          <h4 className="PLMERPData-page-heading">Migration</h4>
          <p className="plmimplementationparagraph">
            We help you to migrate your existing data from one system to another
            system by using various tools and techniques. We ensure that data
            integrity is maintained during migration.
          </p>
          <h5 className="migration-heading">SolidWorks Legacy Data Migration</h5>
         <p className="plmimplementationparagraph">We have unique methodology developed to migrate SolidWorks legacy data using Bulk data import and export functionalities to Teamcenter which includes : </p>
         <ol className="custom-ordered-list">
          <li>Data Assessment & Analysis</li>
          <li>Data Cleanup</li>
          <li>Data Migration and Testing</li>
          <li>Production Rollout</li>
        </ol>
         <h5 className="migration-heading">SolidWorks design data migration to NX</h5>
        <ol className="custom-ordered-list">
          <li>Loading SolidWorks data and corresponding metadata in Teamcenter  </li>
          <li>Content Migration Manager for SolidWorks configuration  </li>
          <li>  Establish a process of migration & data verification like drawing, model, BOM etc. </li>
        </ol>
          </div>
      </div>
      <Letsgetintouch/>
    </section>
  );
};

export default TISolidworks;
